import { RouteType } from '@api/common/route-type';
import { Color } from 'ol/color';
import { MVT } from 'ol/format';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTile from 'ol/source/VectorTile';
import Circle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style, { StyleFunction } from 'ol/style/Style';
import Text from 'ol/style/Text';
import { ZoomLevel } from '../domain/zoom-level';
import { OldLayers } from './old-layers';
import { OldMapLayer } from './old-map-layer';

export class OldOpendataVectorTileLayer {
  private static readonly largeMaxZoomResolution = /* zoomLevel 13 */ 19.109;
  private static readonly smallStyle = this.buildSmallStyle();
  private static readonly largeStyle = this.buildLargeStyle();

  static build(routeType: RouteType, id: string, name: string, dir: string): OldMapLayer {
    const source = new VectorTile({
      tileSize: 512,
      minZoom: ZoomLevel.vectorTileMinZoom,
      maxZoom: ZoomLevel.vectorTileMaxZoom,
      format: new MVT(),
      url: `/tiles/opendata/${dir}/{z}/{x}/{y}.mvt`,
    });

    const layer = new VectorTileLayer({
      zIndex: OldLayers.zIndexPoiLayer,
      source,
      renderBuffer: 40,
      declutter: false,
      className: 'poi',
      renderMode: 'vector',
    });

    layer.setStyle(this.styleFunction());

    return new OldMapLayer(
      id,
      name,
      ZoomLevel.vectorTileMinZoom,
      ZoomLevel.vectorTileMaxOverZoom,
      'vector',
      layer,
      routeType,
      null
    );
  }

  private static styleFunction(): StyleFunction {
    return (feature, resolution) => {
      const name = feature.get('name');
      const large = resolution < this.largeMaxZoomResolution;
      let style = this.smallStyle;
      if (large) {
        style = this.largeStyle;
        style.getText().setText(name);
      }
      return style;
    };
  }

  private static buildLargeStyle(): Style {
    const red: Color = [255, 0, 0];
    const white: Color = [255, 255, 255];
    return new Style({
      stroke: new Stroke({
        color: red,
        width: 6,
      }),
      image: new Circle({
        radius: 16,
        fill: new Fill({
          color: white,
        }),
        stroke: new Stroke({
          color: red,
          width: 4,
        }),
      }),
      text: new Text({
        text: '',
        textAlign: 'center',
        textBaseline: 'middle',
        font: '14px Arial, Verdana, Helvetica, sans-serif',
        stroke: new Stroke({
          color: white,
          width: 5,
        }),
      }),
    });
  }

  private static buildSmallStyle(): Style {
    const red: Color = [255, 0, 0];
    const white: Color = [255, 255, 255];
    const lineDash = null; //[5, 5];
    return new Style({
      stroke: new Stroke({
        color: red,
        lineDash,
        width: 3,
      }),
      image: new Circle({
        radius: 3,
        fill: new Fill({
          color: white,
        }),
        stroke: new Stroke({
          color: red,
          width: 2,
        }),
      }),
    });
  }
}
